var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.4578 1.54713C17.9691 1.05664 17.3889 0.667556 16.7503 0.402095C16.1117 0.136633 15.4272 0 14.7359 0C14.0446 0 13.3601 0.136633 12.7215 0.402095C12.0829 0.667556 11.5026 1.05664 11.0139 1.54713L9.99974 2.56458L8.98554 1.54713C7.99842 0.556847 6.6596 0.000513297 5.26361 0.000513307C3.86761 0.000513318 2.52879 0.556847 1.54168 1.54713C0.554557 2.53741 1.0401e-08 3.88051 0 5.28098C-1.0401e-08 6.68145 0.554557 8.02456 1.54168 9.01484L2.55588 10.0323L9.99974 17.5L17.4436 10.0323L18.4578 9.01484C18.9467 8.52458 19.3346 7.9425 19.5992 7.30183C19.8638 6.66116 20 5.97447 20 5.28098C20 4.5875 19.8638 3.9008 19.5992 3.26014C19.3346 2.61947 18.9467 2.03738 18.4578 1.54713Z","fill":"#303030"}));
}

Heart.defaultProps = {"width":"20","height":"18","viewBox":"0 0 20 18","fill":"none"};

module.exports = Heart;

Heart.default = Heart;
